import MkuSteps from './src/steps';

MkuSteps.install = function (Vue) {
  Vue.component(MkuSteps.name, MkuSteps);
};

export default MkuSteps;
